import styled, { css } from 'styled-components';

const Chip = styled.div`
    position: relative;
    border-radius: 24px;
    display: inline-block;
    vertical-align: top;
    margin-right: ${(props) => props.theme.spacers.S};
    background: ${({ type, theme }) =>
        ['promotional', 'lowStock'].includes(type) ? theme.colors.Foreground : theme.colors.Color1};
    color: ${({ type, theme }) =>
        ['promotional', 'lowStock'].includes(type) ? theme.colors.Background : '#FFFFFF'};
`;

const ChipTypography = styled.h5`
    margin: 3px 6px;
    ${(props) => css(props.theme.typography.SmallCapsHeadline)};
    font-size: 8.5px;
    line-height: 10px;
`;

export { Chip, ChipTypography };
